// How much of the room is shown while the loading screen hands over to it. The loader moves these values and
// World applies them every frame: first the desk, the chair and the small things on the desk fade in, then
// everything else (the other props, walls, floor, rock, sea) dissolves in around them. The defaults show
// everything, e.g. with ?debug.
export const reveal = {
    desk: 1,
    background: 1,
    ready: false, // set by World once the models are in
};
